import React, { useState } from 'react';
import './SignUp.css'; // Import the CSS file
// import "../../../src/App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoMdCloseCircle } from "react-icons/io";
import { GiCombinationLock } from "react-icons/gi";
import { FaMobileAlt, FaCaretDown, FaUser, FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const SignUp = (props) => {
  const navigate = useNavigate();
  const { signup } = useAuth();

  const [formData, setFormData] = useState({
    site_code: apiBaseUrl.sitecodes,
    user_name: "",
    password: "",
    user_type: "User",
    master_id: apiBaseUrl.superAdmin,
    refercode: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle password visibility

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // Add this function in your component
  const handleGetOtp = async (e) => {
    e.preventDefault();
    const mobile = formData.user_name.replace(/\D/g, '').slice(-10); // Only last 10 digits
    if (!mobile || mobile.length !== 10) {
      toast.error("Enter a valid 10-digit mobile number");
      return;
    }
    try {
      const response = await axios.post(`${apiBaseUrl.apiUrl}otps/sendOtp`, {
        user_name: mobile
      });
      if (response.data.success) {
        toast.success("OTP sent successfully!");
      } else {
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    return false;

    if (confirmPassword !== formData.password) {
      toast.error("Password Not Matched!", { autoClose: 2000 });
      return false;
    }

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/addUsers`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(formData),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("Registered successful!", { autoClose: 2000 });

          // localStorage.setItem(
          //   "userdata",
          //   JSON.stringify(response.data.resultData)
          // );
          console.log('response.data.resultData', response.data.resultData);
          signup(response.data.resultData[0]);

          if (props?.togglePopup) {
            props.togglePopup();
          }
          if (props?.handleClose) {
            props.handleClose();
          }

        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during registering", { autoClose: 2000 });
      });
  };


  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword); // Toggle between showing and hiding password
  };

  return (
    <>
      {/* Login Button */}
      {/* <button type="button" className="btn btn-warning" onClick={togglePopup}>Sign Up</button> */}
      {/* <button className="pushable-signup submit-btn login-trigger " onClick={togglePopup}>
        <span className="front-signup">Sign Up</span> 
      </button> */}

      {/* Popup */}
      {props?.showForgotPopup && (
        <div className="login-popup-overlay" onClick={props?.toggleForgotPopup}>
          <div className="login-popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn">
              <IoMdCloseCircle onClick={props?.toggleForgotPopup} />
            </span>
            <div className='login-popup-logo'>
              <img className='form-logo' src="../Images/logo.png" alt="" />
            </div>
            <form onSubmit={handleSubmit}>
              <div className="relative border border-gray-300 rounded-lg overflow-hidden mb-3">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-600 z-10">
                  +91
                </span>
                <input
                  type="number"
                  name="user_name"
                  value={formData.user_name}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter Your 10 Digit Number"
                  className="w-full pl-12 pr-24 py-2 focus:outline-none text-black"
                  required
                />
                <button
                  className="getotp p-1 bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef] rounded-[10px] absolute top-1/2 right-2 transform -translate-y-1/2 text-white text-xs md:text-sm w-16 md:w-20"
                  // disabled={otpBtn}
                  onClick={(e) => handleGetOtp(e)}
                >
                  Get OTP
                </button>
              </div>
              <div className="signup-otp">
                <input type="number" name="number" placeholder="Enter OTP" className='otp-input' style={{ borderRadius: 5 }} />
              </div>

              <div className="relative mb-3">
                <span className="text-black w-[281px] ml-2">Password</span>
                <div className="flex items-center border border-gray-300 rounded-lg h-[43px]">
                  <div className="pl-3 pr-2 text-yellow-500">
                    <GiCombinationLock size={20} />
                  </div>
                  <input
                    className="flex-1 py-2 pr-10 focus:outline-none border-none"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    required
                    value={formData.password}
                    onChange={(e) => handleInputChange(e)}
                  />
                  <button
                    type="button"
                    className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                  </button>
                </div>
              </div>
              {/* <div className="signup-password">
                <GiCombinationLock size={20} color="#e9b02e" style={{ marginRight: 0, marginLeft: 5 }} />
                <input
                  className='password-input'
                  type={showConfirmPassword ? 'text' : 'password'}  // Toggle between 'text' and 'password'
                  name="confirmpass"
                  placeholder="Confirm Password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span className="confirm-password-toggle-signup" onClick={toggleConfirmPasswordVisibility}>
                  {showConfirmPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                </span> 
              </div> */}

              {/* <input type="text"
                name="refercode"
                placeholder="Referral Code (if any)"
                value={formData.refercode}
                onChange={(e) => handleInputChange(e)} /> */}
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                <label className="form-check-label text-black" for="flexCheckDefault">
                  Remember me
                </label>
              </div>
              <button type='submit' className=" submit-btn m-auto p-2">
                <span className="front">
                  Update
                </span>
              </button>
              {/* <span className='other-login'>Or register with</span>
              <span className="other-button">
                <button className='google'><img src="./Images/google.png" alt="" className='google-image' />Google</button>
                <button className='whatsapp'><img src="./Images/whatsapp.png" alt="" className='whatsapp-image' />WhatsApp</button>
              </span> */}
              <span className='new-account' onClick={() => props?.togglePopup()}>Already have an account? Login</span> {/* Added onClick event */}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
